import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import ReportDefinitions from '../../../../../../common/config/ReportDefinitions';
import Report from '../../../../../common/components/Report';
import {
  getColumns,
  getData,
  getGeneratedOnDateTime,
  getIsLoading,
} from '../redux/selectors/DespatchMeasurementsHourlyEvolutionSelectors';

export class DespatchMeasurementsHourlyEvolutionContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showChart: false,
      chartMeta: {},
    };
  }

  setChartMeta = (chartMeta) => {
    this.setState({
      chartMeta,
      showChart: true,
    });
  };

  closeChart = () => {
    this.setState({
      showChart: false,
    });
  };

  render() {
    return (
      <Report
        reportId={ReportDefinitions.DESPATCH_MEASUREMENTS_HOURLY_EVOLUTION.id}
        generatedOnDateTime={this.props.generatedDateTime}
        isLoading={this.props.isLoading}
        data={this.props.data}
        columns={this.props.columns(this.setChartMeta)}
        showChart={this.state.showChart}
        chartMeta={this.state.chartMeta}
        closeChart={this.closeChart}
        className="despatchMeasurementsHourlyEvolutionReport"
      />
    );
  }
}

function mapStateToProps(state, props) {
  return {
    data: getData(state, props),
    columns: getColumns(state, props),
    generatedDateTime: getGeneratedOnDateTime(state, props),
    isLoading: getIsLoading(state, props),
  };
}

DespatchMeasurementsHourlyEvolutionContainer.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  columns: PropTypes.func,
  generatedDateTime: PropTypes.string,
  isLoading: PropTypes.bool,
};

export default connect(mapStateToProps)(DespatchMeasurementsHourlyEvolutionContainer);
